
    var riot = require('riot')
    
riot.tag2('pse', '<toaster></toaster> <loading if="{loading}"></loading> <pseapply if="{showApply &amp;&amp; !loading}"></pseapply> <submit_details if="{showSubmit &amp;&amp; !loading}" opts="{opts}" submit="{handleRealSubmit}" back="{handleBack}"></submit_details> <div if="{!showApply &amp;&amp; !showSubmit &amp;&amp; !loading}"> <ul class="nav nav-tabs"> <li class="{active: tags.routehandler.tagname == \'personal_details\'}"><a href="personal_details" class="heading">Personal Details</a></li> <li class="{active: tags.routehandler.tagname == \'referee_details\'}"><a href="referee_details" class="heading">Referees</a></li> <li class="{active: tags.routehandler.tagname == \'education_details\'}"><a href="education_details" class="heading">Education</a></li> <li class="{active: tags.routehandler.tagname == \'qualification_details\'}"><a href="qualification_details" class="heading">Professional Qualifications</a></li> <li class="{active: tags.routehandler.tagname == \'training_details\'}"><a href="training_details" class="heading">Training</a></li> <li class="{active: tags.routehandler.tagname == \'career_details\'}"><a href="career_details" class="heading">Career Summary</a></li> <li class="{active: tags.routehandler.tagname == \'experience_details\'}"><a href="experience_details" class="heading">Simulation Experience</a></li> <li class="{active: tags.routehandler.tagname == \'competency_details\'}"><a href="competency_details" class="heading">Competencies Claimed</a></li> </ul> <routehandler routes="{routes}" options="{options}" opts="{opts}" psedata="{psedata}" onupdate="{handleUpdate}" selects="{selects}" infos="{infos}" files="{files}" errors="{errors}"></routehandler> <div class="row"> <div class="col-xs-12"> <div class="btn-toolbar pull-right"><a onclick="{goToNextError}" if="{errors.length}" class="btn btn-danger">{errors.length} errors found - show error {errorIndex+1}</a><a onclick="{handleValidate}" if="{!errors || errors.length == 0}" class="btn btn-success">Validate Form</a><a onclick="{handleViewPDF}" class="btn btn-success">View Application as PDF</a><a onclick="{handleSubmit}" class="btn btn-success">Submit Application</a><a onclick="{handleSave}" class="btn btn-success">Save Changes</a></div> </div> </div> </div>', 'pse { display: block; margin-bottom: 100px; } pse .tab-pane { overflow: hidden; padding-top: 20px; } pse .tab-pane h3 { margin-top: 0; } pse .nav-tabs li a { padding: 5px; font-size: 12px; } pse loading { display: block; padding-top: 20vh; padding-bottom: 20vh; }', '', function(opts) {
this.loading = true;

this.showApply = false;

this.showSubmit = false;

this.routes = [
  {
    route: "personal_details",
    tag: "personal_details"
  }, {
    route: "referee_details/:referee_id?",
    tag: "referee_details"
  }, {
    route: "education_details/:education_id?",
    tag: "education_details"
  }, {
    route: "qualification_details/:qualification_id?",
    tag: "qualification_details"
  }, {
    route: "training_details/:training_id?",
    tag: "training_details"
  }, {
    route: "career_details/:career_id?",
    tag: "career_details"
  }, {
    route: "experience_details/:simulation_id?",
    tag: "experience_details"
  }, {
    route: "competency_details/:competency_id?",
    tag: "competency_details"
  }, {
    route: "*",
    tag: "personal_details"
  }
];

this.files = [];

this.options = {
  base: opts.pagepath,
  hashbang: true
};

this.validation = {
  personal: {
    pers_forenames: true,
    pers_surname: true,
    pers_address1: true,
    pers_postcode: true,
    pers_country: true,
    pers_email: true,
    pers_position: true,
    pers_organisation: true,
    pers_orgjoined: function(field, tab, all, tabFields, files) {
      if (field == null) {
        field = "";
      }
      if (field === "") {
        return false;
      }
      return field.match(/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/);
    },
    pers_orgaddress1: true,
    pers_orgpostcode: true,
    pers_orgcountry: true,
    pers_orgtelephone: true,
    pers_id: function(field, tab, all, tabFields, files) {
      return files.filter(function(f) {
        return f.path.match('^id_');
      }).length > 0;
    }
  },
  referees: {
    ref_name: true,
    ref_relationship: true,
    ref_refemail: true
  },
  educations: {
    qual_files: (function(_this) {
      return function(field, tab, all, tabFields, files) {
        if (!field) {
          return true;
        }
        if (!_this.validateRequired(tabFields.qual_title)) {
          return true;
        }
        return files.filter(function(f) {
          return f.path.match('^ed_' + tab + '_');
        }).length > 0;
      };
    })(this),
    qual_verification: (function(_this) {
      return function(field, tab, all, tabFields, files) {
        var ref;
        if (!field) {
          return true;
        }
        return ((ref = _this.selects.education_verifications.filter(function(l) {
          return l.value === field;
        })) != null ? ref.length : void 0) > 0;
      };
    })(this),
    qual_date: true
  },
  qualifications: {
    prof_date: true,
    qual_files: (function(_this) {
      return function(field, tab, all, tabFields, files) {
        if (!_this.validateRequired(tabFields.prof_qualification)) {
          return true;
        }
        return files.filter(function(f) {
          return f.path.match('^pq_' + tab + '_');
        }).length > 0;
      };
    })(this),
    qual_verification: (function(_this) {
      return function(field, tab, all, tabFields, files) {
        var ref;
        if (!field) {
          return true;
        }
        return ((ref = _this.selects.qualification_verifications.filter(function(l) {
          return l.value === field;
        })) != null ? ref.length : void 0) > 0;
      };
    })(this)
  },
  trainings: {
    edu_date_start: true
  },
  careers: {
    jobs_date_start: true
  },
  simulations: {
    comp_job: true,
    comp_description: true,
    comp_role: true,
    comp_weeks: true,
    comp_products: true,
    comp_tools: true,
    comp_start: function(field, tab, all, tabFields, files) {
      if (field == null) {
        field = "";
      }
      if (field === "") {
        return false;
      }
      return field.match(/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/);
    },
    comp_end: function(field, tab, all, tabFields, files) {
      if (field == null) {
        field = "";
      }
      if (field === "") {
        return false;
      }
      return field.match(/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/);
    }
  },
  competencies: {
    modname: true,
    modlevel: (function(_this) {
      return function(field, idx, all, tabFields, files) {
        var ref;
        return ((ref = _this.selects.levels.filter(function(l) {
          return l.value === field;
        })) != null ? ref.length : void 0) > 0;
      };
    })(this),
    modsim: (function(_this) {
      return function(field, idx, all, tabFields, files) {
        var exp;
        if (!_this.validateRequired(tabFields.modname) || !_this.validateRequired(tabFields.modlevel) || tabFields.modlevel === 'level1') {
          return true;
        }
        exp = all.simulations.reduce(function(sum, sims) {
          var ref;
          idx = (ref = sims.comp_types) != null ? ref.indexOf(tabFields.modname) : void 0;
          if ((idx != null) && idx > -1) {
            sum += +sims.comp_length[idx];
          }
          return sum;
        }, 0);
        return exp >= 12;
      };
    })(this),
    referee: true
  }
};

this.selects = require('./selects.json');

this.infos = require('./infos.json');

this.on('mount', function() {
  return fetch('/duocms/api/pse', {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((function(_this) {
    return function(res) {
      return res.json();
    };
  })(this)).then((function(_this) {
    return function(json) {
      if (json.data == null) {
        return Promise.reject();
      }
      return Promise.resolve(json.data);
    };
  })(this)).then((function(_this) {
    return function(data) {
      _this.files = data.files;
      try {
        return Promise.resolve(JSON.parse(data.formdata.psedata));
      } catch (error) {
        return Promise.resolve({});
      }
    };
  })(this)).then((function(_this) {
    return function(data1) {
      _this.data = data1;
      _this.showThings(false);
      _this.psedata = {
        personal: _this.data.iseform1,
        careers: Object.keys(_this.data.iseform2).filter(function(k) {
          return k.match('^job[0-9]+$');
        }).map(function(k) {
          return _this.data.iseform2[k];
        }),
        educations: Object.keys(_this.data.iseform5).filter(function(k) {
          return k.match('^qual[0-9]+$');
        }).map(function(k) {
          return _this.data.iseform5[k];
        }),
        referees: Object.keys(_this.data.iseform4).filter(function(k) {
          return k.match('^ref[0-9]+$');
        }).map(function(k) {
          return _this.data.iseform4[k];
        }),
        trainings: Object.keys(_this.data.iseform3).filter(function(k) {
          return k.match('^edu[0-9]+$');
        }).map(function(k) {
          return _this.data.iseform3[k];
        }),
        qualifications: Object.keys(_this.data.iseform6).filter(function(k) {
          return k.match('^proqual[0-9]+$');
        }).map(function(k) {
          return _this.data.iseform6[k];
        }),
        competencies: Object.keys(_this.data.iseform8).filter(function(k) {
          return k.match('^sim[0-9]+$');
        }).map(function(k) {
          return _this.data.iseform8[k];
        }),
        simulations: Object.keys(_this.data.iseform7).filter(function(k) {
          return k.match('^comp[0-9]+$');
        }).map(function(k) {
          return _this.data.iseform7[k];
        })
      };
      if (_this.tags.routehandler.tagname === 'personal_details') {
        _this.tags.routehandler.opts.page.redirect('personal_details');
      }
      return _this.update();
    };
  })(this))["catch"]((function(_this) {
    return function(err) {
      _this.showThings(true);
      return _this.update();
    };
  })(this));
});

this.showThings = function(showApply) {
  this.showApply = showApply;
  return setTimeout((function(_this) {
    return function() {
      _this.loading = false;
      return _this.update();
    };
  })(this), 1500);
};

this.addFile = (function(_this) {
  return function(file) {
    _this.files.push(file);
    return _this.update();
  };
})(this);

this.removeFile = (function(_this) {
  return function(file) {
    _this.files = _this.files.filter(function(f) {
      return f.path !== file.path;
    });
    return _this.update();
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(tab, field, value) {
    var ref, ref1;
    if (tab === 'files') {
      if (field === 'add') {
        _this.addFile(value);
      }
      if (field === 'remove') {
        _this.removeFile(value);
      }
      if (((ref = _this.errors) != null ? ref.length : void 0) > 0) {
        _this.validate();
      }
    } else {
      _this.psedata[tab][field] = value;
      if (((ref1 = _this.errors) != null ? ref1.length : void 0) > 0) {
        _this.validate();
      }
    }
    return _this.update();
  };
})(this);

this.handleValidate = function() {
  var valid;
  this.validate();
  valid = this.errors.length === 0;
  if (valid) {
    this.tags.toaster.trigger('add', {
      title: 'Successful Validation',
      message: "Your application is valid",
      type: 'success'
    });
  } else {
    this.tags.toaster.trigger('add', {
      title: 'Failed Validation',
      message: "Your application isn't complete, ensure all fields marked with an * are complete",
      type: 'warning'
    });
  }
  return valid;
};

this.handleViewPDF = function() {
  this.handleSave();
  window.location.assign('/duocms/api/psepdf');
  return null;
};

this.goToNextError = (function(_this) {
  return function() {
    if (_this.errorIndex > _this.errors.length - 1) {
      _this.errorIndex = 0;
    }
    _this.errorIndex = _this.errorIndex < _this.errors.length - 1 ? _this.errorIndex + 1 : 0;
    return _this.tags.routehandler.opts.page.redirect(_this.errors[_this.errorIndex].link);
  };
})(this);

this.handleSubmit = function() {
  if (this.handleValidate()) {
    this.showSubmit = true;
    return this.update();
  }
};

this.handleBack = (function(_this) {
  return function() {
    _this.showSubmit = false;
    return _this.update();
  };
})(this);

this.handleRealSubmit = (function(_this) {
  return function() {
    console.log('submitting');
    return fetch('/duocms/api/pse/submit', {
      method: 'POST',
      credentials: "include",
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': opts.csrf
      },
      body: JSON.stringify({
        iseform1: _this.psedata.personal,
        iseform2: _this.toObject(_this.psedata.careers, 'job'),
        iseform5: _this.toObject(_this.psedata.educations, 'qual'),
        iseform4: _this.toObject(_this.psedata.referees, 'ref'),
        iseform3: _this.toObject(_this.psedata.trainings, 'edu'),
        iseform6: _this.toObject(_this.psedata.qualifications, 'proqual'),
        iseform8: _this.toObject(_this.psedata.competencies, 'sim'),
        iseform7: _this.toObject(_this.psedata.simulations, 'comp')
      })
    }).then(function(res) {
      return res.json();
    }).then(function(res) {
      console.log('load files', res.data);
      if (!res.data) {
        _this.tags.toaster.trigger('add', {
          title: 'Error',
          message: "Your application is missing some files",
          type: 'error'
        });
        return fetch('/duocms/api/pse', {
          method: 'GET',
          credentials: "include",
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function(res) {
          return res.json();
        }).then(function(json) {
          if (json.data == null) {
            return Promise.reject();
          }
          return Promise.resolve(json.data);
        }).then(function(data) {
          _this.files = data.files;
          _this.validate();
          return _this.goToNextError();
        });
      } else {
        _this.tags.toaster.trigger('add', {
          title: 'Success',
          message: "Your application has been submitted",
          type: 'success'
        });
        return setTimeout(function() {
          return window.location.pathname += 'submit';
        }, 1500);
      }
    })["catch"](function(err) {
      console.log('err', err.json());
      return _this.tags.toaster.trigger('add', {
        title: 'Error',
        message: "Your application could not be submitted",
        type: 'error'
      });
    });
  };
})(this);

this.handleSave = function() {
  return fetch('/duocms/api/pse', {
    method: 'PUT',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json',
      'x-csrf-token': opts.csrf
    },
    body: JSON.stringify({
      iseform1: this.psedata.personal,
      iseform2: this.toObject(this.psedata.careers, 'job'),
      iseform5: this.toObject(this.psedata.educations, 'qual'),
      iseform4: this.toObject(this.psedata.referees, 'ref'),
      iseform3: this.toObject(this.psedata.trainings, 'edu'),
      iseform6: this.toObject(this.psedata.qualifications, 'proqual'),
      iseform8: this.toObject(this.psedata.competencies, 'sim'),
      iseform7: this.toObject(this.psedata.simulations, 'comp')
    })
  }).then((function(_this) {
    return function(res) {
      return {
        res: res,
        data: res.json()
      };
    };
  })(this)).then((function(_this) {
    return function(arg) {
      var data, res;
      res = arg.res, data = arg.data;
      if (res.status === 200) {
        return _this.tags.toaster.trigger('add', {
          title: 'Success',
          message: "Your application has been saved",
          type: 'success'
        });
      } else if (res.status === 401) {
        return _this.tags.toaster.trigger('add', {
          title: 'Error',
          message: "You have been logged out. Try logging in a different tab, then resaving here to avoid losing any updates.",
          type: 'error'
        });
      } else {
        return _this.tags.toaster.trigger('add', {
          title: 'Error',
          message: "Your application could not be saved",
          type: 'error'
        });
      }
    };
  })(this))["catch"]((function(_this) {
    return function(err) {
      return _this.tags.toaster.trigger('add', {
        title: 'Error',
        message: "Your application could not be saved",
        type: 'error'
      });
    };
  })(this));
};

this.toObject = function(arr, name) {
  var obj;
  obj = {};
  arr.map(function(a, i) {
    return obj[name + i] = a;
  });
  return obj;
};

this.validate = function() {
  this.errorIndex = 0;
  this.errors = [];
  return Object.keys(this.psedata).reduce((function(_this) {
    return function(valid, tab, i, keys) {
      if (_this.validation[tab] == null) {
        return valid;
      }
      if (Array.isArray(_this.psedata[tab])) {
        return valid & _this.validateArray(tab, _this.psedata[tab], _this.validation[tab]);
      }
      return valid & _this.validateObject(tab, null, _this.psedata[tab], _this.validation[tab]);
    };
  })(this), true);
};

this.validateObject = function(tab, subtab, obj, validationObj) {
  if (obj == null) {
    return false;
  }
  return Object.keys(validationObj).reduce((function(_this) {
    return function(valid, k, i, keys) {
      var ref, ref1, v;
      if (typeof validationObj[k] === 'function') {
        v = validationObj[k](obj[k], subtab + 1, _this.psedata, (ref = _this.psedata) != null ? (ref1 = ref[tab]) != null ? ref1[subtab] : void 0 : void 0, _this.files);
      }
      if (typeof validationObj[k] === 'boolean' && validationObj[k]) {
        v = _this.validateRequired(obj[k]);
      }
      if (!v) {
        _this.addError(tab, subtab, k);
      }
      return valid && v;
    };
  })(this), true);
};

this.validateArray = function(tab, arr, validationObj) {
  if (arr == null) {
    return false;
  }
  return arr.reduce((function(_this) {
    return function(valid, k, i, keys) {
      var v;
      v = _this.validateObject(tab, i, k, validationObj);
      return valid && v;
    };
  })(this), true);
};

this.validateRequired = function(field) {
  var val;
  if (field == null) {
    return false;
  }
  val = field.trim();
  return (val != null ? val.length : void 0) > 0;
};

this.addError = function(tab, subtab, field) {
  var link;
  link = (function() {
    switch (tab) {
      case 'personal':
        return 'personal_details';
      case 'referees':
        return 'referee_details';
      case 'educations':
        return 'education_details';
      case 'qualifications':
        return 'qualification_details';
      case 'trainings':
        return 'training_details';
      case 'careers':
        return 'career_details';
      case 'simulations':
        return 'experience_details';
      case 'competencies':
        return 'competency_details';
      default:
        return 'personal_details';
    }
  })();
  if (subtab != null) {
    link = link + "/" + (subtab + 1);
  }
  return this.errors.push({
    tab: tab,
    subtab: subtab,
    field: field,
    link: link
  });
};
});
    
  